import React from 'react';

export default function TypingIndicator() {
    return (
        <div className="oc-message-row oc-message-row-bot">
            <div className="oc-avatar">
                <img src="/cb_logo.png" alt="" className="oc-avatar-img" />
            </div>
            <div className="oc-bubble oc-bubble-bot oc-typing-bubble">
                <span className="oc-typing-dot" />
                <span className="oc-typing-dot" />
                <span className="oc-typing-dot" />
            </div>
        </div>
    );
}
